import { Row, Col } from 'src/componentes/grid';
import {
  LookupField,
  createLookupModel,
} from 'src/componentes/filtro/search-drawer/searchDrawerUtils';
import ColaboradorEGrupoSimplificadoLookup from 'src/lookups/ColaboradorEGrupoSimplificadoLookup';
import { useSelector } from 'react-redux';
import { useIntl } from 'react-intl';
import { capitalizeFirstLetter } from 'src/utils/string';
import ItemOrganizacaoLookup from 'src/lookups/item-organizacao';
import Input from 'src/componentes/input';
import DatePicker from 'src/componentes/date-picker';
import Checkbox from 'src/componentes/checkbox';

function DistribuicaoCopiasControladasDrawer({ model }) {
  const resources = useSelector((state) => state.user.termos);
  const intl = useIntl();
  return (
    <Row>
      <Col md={12}>
        <ColaboradorEGrupoSimplificadoLookup
          abrirEmDrawer
          labelComoTitulo
          multi
          clearable
          model={{
            label: capitalizeFirstLetter(resources?.colaboradores),
            value: model.getModel('colaboradores')?.value,
            requestChange: model.getModel('colaboradores')?.requestChange,
          }}
        />
      </Col>
      <Col md={12}>
        <LookupField
          Component={ItemOrganizacaoLookup}
          clearable
          multi
          model={createLookupModel(
            resources?.areas,
            model.getModel('areas')?.value,
            model.getModel('areas')?.requestChange
          )}
        />
      </Col>
      <Col md={12}>
        <Checkbox
          model={createLookupModel(
            intl.formatMessage(
              { id: 'label.considerarAreasSubordinadas' },
              { areas: resources?.areas || 'Áreas' }
            ),
            model.getModel('considerarAreasSubordinadas')?.value,
            model.getModel('considerarAreasSubordinadas')?.requestChange
          )}
          style={{ marginBottom: 10 }}
        />
      </Col>
      <Col md={12}>
        <DatePicker
          model={{
            ...model.getModel('dataCopia'),
            label: capitalizeFirstLetter(
              intl.formatMessage({ id: 'labelDataCopia' })
            ),
          }}
        />
      </Col>
      <Col md={12}>
        <Input
          model={{
            ...model.getModel('numeroCopia'),
            label: capitalizeFirstLetter(
              intl.formatMessage({ id: 'labelNumeroCopia' })
            ),
          }}
        />
      </Col>
      <Col md={12}>
        <Input
          model={{
            ...model.getModel('codigoVersao'),
            label: capitalizeFirstLetter(
              intl.formatMessage({ id: 'labelCodigoVersao' })
            ),
          }}
        />
      </Col>
    </Row>
  );
}

export default DistribuicaoCopiasControladasDrawer;
